import { httpClient } from "@coworker/http-client";
import { NewTeamDataType } from "../types/TeamMutationTypes";

async function addTeam(newTeamData: NewTeamDataType) {
  const result = await httpClient.core.post(`/teams`, {
    body: newTeamData,
  });

  return result;
}

export default addTeam;
